import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "code-confirmation-modal",
  "data-bs-backdrop": "--static",
  "data-bs-keyboard": "false",
  tabindex: "-1",
  "aria-labelledby": "codeConfirmation",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header bg-secondary text-light" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "col d-block text-center fs-5 fw-bold" }
const _hoisted_7 = { class: "row flex-row" }
const _hoisted_8 = { class: "d-flex col col-sm-9 mx-auto" }
const _hoisted_9 = { class: "row mt-4" }
const _hoisted_10 = {
  key: 0,
  class: "col col-sm-10 offset-sm-1 small"
}
const _hoisted_11 = {
  class: "alert alert-danger alert-dismissible fade show text-center",
  role: "alert"
}
const _hoisted_12 = { class: "modal-footer justify-content-end" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[18] || (_cache[18] = _createElementVNode("h5", { class: "modal-title" }, [
            _createElementVNode("i", { class: "fas fa-user-shield fa-fw me-2" }),
            _createTextVNode(" Verificación de Identidad ")
          ], -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
            "aria-label": "Close"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, [
            _cache[19] || (_cache[19] = _createTextVNode(" Para guardar los cambios debes ingresar el código de ", -1)),
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "fw-bold" }, "5 números", -1)),
            _cache[21] || (_cache[21] = _createTextVNode(" que hemos ", -1)),
            _cache[22] || (_cache[22] = _createElementVNode("span", { class: "fw-bold" }, " enviado a tu correo electrónico registrado ", -1)),
            _cache[23] || (_cache[23] = _createTextVNode(" y que coincida con este código de identificación: ", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.requestTag), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg px-1 me-1 mx-sm-2 text-center fw-bold",
                id: "code-1",
                type: "text",
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.autoTab($event))),
                onKeydown: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoBackspace($event))),
                onPaste: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.pasteCode && _ctx.pasteCode(...args))),
                ref: "code-1",
                maxlength: "1",
                "aria-label": "Primer dígito",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.code[0]) = $event)),
                autofocus: ""
              }, null, 544), [
                [_vModelText, _ctx.code[0]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg px-1 me-1 mx-sm-2 text-center fw-bold",
                id: "code-2",
                type: "text",
                onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.autoTab($event))),
                onKeydown: _cache[6] || (_cache[6] = ($event: any) => (_ctx.autoBackspace($event))),
                ref: "code-2",
                maxlength: "1",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.code[1]) = $event)),
                "aria-label": "Segundo dígito"
              }, null, 544), [
                [_vModelText, _ctx.code[1]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg px-1 me-1 mx-sm-2 text-center fw-bold",
                id: "code-3",
                type: "text",
                onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.autoTab($event))),
                onKeydown: _cache[9] || (_cache[9] = ($event: any) => (_ctx.autoBackspace($event))),
                ref: "code-3",
                maxlength: "1",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.code[2]) = $event)),
                "aria-label": "Tercer dígito"
              }, null, 544), [
                [_vModelText, _ctx.code[2]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg px-1 me-1 mx-sm-2 text-center fw-bold",
                id: "code-4",
                type: "text",
                onKeyup: _cache[11] || (_cache[11] = ($event: any) => (_ctx.autoTab($event))),
                onKeydown: _cache[12] || (_cache[12] = ($event: any) => (_ctx.autoBackspace($event))),
                ref: "code-4",
                maxlength: "1",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.code[3]) = $event)),
                "aria-label": "Cuarto dígito"
              }, null, 544), [
                [_vModelText, _ctx.code[3]]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "form-control form-control-lg px-1 me-0 mx-sm-2 text-center fw-bold",
                id: "code-5",
                type: "text",
                onKeyup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.autoTab($event))),
                onKeydown: _cache[15] || (_cache[15] = ($event: any) => (_ctx.autoBackspace($event))),
                ref: "code-5",
                maxlength: "1",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.code[4]) = $event)),
                "aria-label": "Quinto dígito"
              }, null, 544), [
                [_vModelText, _ctx.code[4]]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[24] || (_cache[24] = _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-fw me-1" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.errorMessage) + " ", 1),
                    _cache[25] || (_cache[25] = _createElementVNode("button", {
                      type: "button",
                      class: "btn-close btn-sm",
                      "data-bs-dismiss": "alert",
                      "aria-label": "Close"
                    }, null, -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[27] || (_cache[27] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-info d-none",
            disabled: ""
          }, " Reenviar Código ", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-secondary",
            disabled: !_ctx.canSave || _ctx.isSaving,
            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.save()))
          }, [
            _cache[26] || (_cache[26] = _createTextVNode(" Aceptar ", -1)),
            (_ctx.isSaving)
              ? (_openBlock(), _createElementBlock("i", _hoisted_14))
              : _createCommentVNode("", true)
          ], 8, _hoisted_13)
        ])
      ])
    ])
  ]))
}